import ImageWithBasePath from "core/img/imagewithbasebath";
import PropTypes from "prop-types";
import React from "react";
import { Info } from "react-feather";
import { Link } from "react-router-dom";

const EmployeePhoto = ({ employee }) => {
  return (
    <div className="slider-product-details">
      <div className="owl-carousel owl-theme product-slide">
        <div className="slider-product">
          {employee?.employeePhoto === "" ? (
            <Link to="#" className="employee-img">
              <ImageWithBasePath
                alt=""
                src={
                  employee?.gender === "M"
                    ? "assets/img/profiles/men.png"
                    : "assets/img/profiles/women.png"
                }
                width={60}
              />
            </Link>
          ) : (
            <img
              src={employee?.employeePhoto}
              alt={employee?.fullName}
              width={60}
            />
          )}
          <h4>{employee?.fullName}</h4>
          {/* <h6>581kb</h6> */}
        </div>
      </div>
    </div>
  );
};

EmployeePhoto.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default EmployeePhoto;
